export default __webpack_public_path__ + "static/media/lock.129ba482.png";